<template>
    <div class="print-warm-list-component">
        <spinner-overlay v-if="loading" class="mt-5" />
        <print-container v-else :title="`Varmeliste ${momentDate.format('DD-MM-YYYY')}`"
            :header_style="{backgroundColor: '#741b47', color: 'white'}">
            <template v-slot:header>
                <div class="h3">VARMELISTE - {{ momentDate.format('dddd DD-MM-YYYY') }}</div>
            </template>
            <div class="container-fluid large-text">
                <div class="row">
                    <div class="col-1"></div>
                    <div class="col-11 pt-5">Total: {{ orderCount }}</div>
                </div>
                <div v-for="(trip, index) in warmTrips" :key="index" class="print-avoid-break-inside"
                    style="padding-top: 50px;">
                    <div class="row">
                        <div class="col-9 delimeter"></div>
                    </div>
                    <div class="row">
                        <div class="col-1"></div>
                        <div class="col-6">
                            <a :href="`/order_management/orders?tab=delivery&_search[delivery_date_from]=${date}&_search[delivery_date_to]=${date}&_search[delivery_zone]=${trip.delivery_zone_id}`"
                                class="print-link" target="_blank">
                                <span v-if="trip.drive_start" class="single-line">{{ trip.drive_start }}</span>
                                <span v-else class="text-danger single-line">Ikke planlagt</span>
                            </a>
                        </div>
                        <div class="col-2">
                            <span class="single-line">{{ trip.driver_name }}</span>
                        </div>
                    </div>
                    <template v-for="order in trip.orders" :key="order.id">
                        <div class="row">
                            <div class="col-1"><i class="far fa-square"></i></div>
                            <div class="col-1 text-danger">VARM</div>
                            <div class="col-5 single-line">{{ order.total_quantity }} x {{ order.productTitle }}</div>
                            <div class="col-2"><a :href="order.url" class="print-link single-line" target="_blank">#{{
                                    order.reference_code }}</a></div>
                        </div>
                        <div v-for="extra, index in order.order_products" class="row" :key="index">
                            <div class="col-2"></div>
                            <div class="col-7">
                                <span class="extra-product-line single-line-block">{{ extra.quantity }} x {{
                                    extra.product ?
                                    extra.product.name : '' }}</span>
                            </div>
                        </div>
                    </template>
                    <div class="row">
                        <div class="col-9 delimeter"></div>
                    </div>
                </div>
            </div>
        </print-container>
    </div>
</template>

<script>
import SpinnerOverlay from '@/components/SpinnerOverlay.vue';
import { Order } from '@/models/order';
import PrintContainer from '@/print/PrintContainer.vue';
import { useRouteDataStore } from '@/stores/route-data';
import axios from 'axios';
import moment from 'moment/moment';
import { computed, ref } from 'vue';

export default {
  components: { PrintContainer, SpinnerOverlay },
  props: {
    delivery_zones: {
      type: Array,
      required: true
    },
    vehicles: {
      type: Array,
      required: true
    },
    drivers: {
      type: Array,
      required: true
    },
  },
  setup (props) {
    const date = computed(() => {
      return new URLSearchParams(window.location.search).get('date');
    });
    const momentDate = computed(() => {
      moment.locale('da');
      return moment(date.value);
    });

    const loading = ref(true);
    const routeDataStore = useRouteDataStore();

    const orderCount = computed(() => {
      return warmTrips.value.map(trip => trip.orders.length).reduce((a, b) => a + b, 0);
    });

    const warmTrips = ref([]);
    
    const tripNames = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
    const getTrips = (orders) => {
      const ordersByTrips = {none: [], A: [], B: [], C: [], D: [], E: [], F: [], G: []};
      for (let i = 0; i < orders.length; i++) {
        const order = orders[i];
        if (order.route_code) {
          ordersByTrips[order.route_code].push(order);
        } else {
          ordersByTrips.none.push(order);
        }
      }
      for (let i = 0; i < tripNames.length; i++) {
        ordersByTrips[tripNames[i]].sort((a, b) => {
          return a.tour_code - b.tour_code;
        });
      }
      ordersByTrips.none.sort((a, b) => {
        return a.deliveryIntervalStart.localeCompare(b.deliveryIntervalStart);
      });
      return ordersByTrips;
    };

    const loadOrders = async () => {
      // loop delivery_zones and get orders
      for (const deliveryZone of props.delivery_zones) {
        await axios
          .get(`/order_management/orders/orders_data?type=deliveries&date=${date.value}&delivery_zone=${deliveryZone.id}`)
          .then(response => {
            const orders = response.data.orders.map(order => {
              return Order.createReactive(order);
            });
            routeDataStore.setRouteData(response.data.route_data);

            //loop orders and add warm orders to warmTrips
            const trips = getTrips(orders);
            for (const tripName of tripNames) {
              const warmOrders = trips[tripName].filter(order => order.delivery_type === 'warm' && order.route_code === tripName);
              // console.log(deliveryZone.title, tripName, trips[tripName].length, warmOrders.length);
              if (warmOrders.length > 0) {
                const firstOrder = trips[tripName][0];
                warmTrips.value.push({
                  drive_start: response.data.route_data === null ? null : firstOrder.driveStart,
                  driver_name: firstOrder.driver_id ? props.drivers.find(driver => driver.id === firstOrder.driver_id).name : '-',
                  vehicle_name: firstOrder.vehicle_id ? props.vehicles.find(vehicle => vehicle.id === firstOrder.vehicle_id).title : '',
                  delivery_zone: deliveryZone.title,
                  delivery_zone_id: deliveryZone.id,
                  trip_name: tripName,
                  orders: warmOrders,
                });
              }
            }
          });
      }
      warmTrips.value.sort((a, b) => {
        if (a.drive_start === b.drive_start) {
          return 0;
        } else if (!a.drive_start) {
          return -1;
        } else if (!b.drive_start) {
          return 1;
        } else {
          return a.drive_start.localeCompare(b.drive_start);
        }
      });
      loading.value = false;
      console.log(warmTrips.value);
      setTimeout(window.print, 250);
    };
    loadOrders();
    return {
      date,
      momentDate,
      warmTrips,
      orderCount,
      loading,
    }
  }
}
</script>

<style lang="scss" scoped>
.print-warm-list-component {
  .delimeter {
    margin: 8px 15px;
    border-top: 0.25mm solid #d0d0d0;
  }
  .text-transparent {
    color: transparent;
  }
}
</style>